import React, { useState, useRef } from "react";
import { Button } from "devextreme-react/button";
import { Box, Popup } from "devextreme-react";

import logoH2Img from "./h2BeccoCRO.png";

import QRCode from "react-qr-code";
import { Item } from "devextreme-react/box";
import { exportComponentAsPNG } from "react-component-export-image";

export default function QRItem(props) {
  //   const { showInfo } = props;

  const { codeNo, type, SEQ } = props;

  const [popupVisible, setPopupVisible] = useState(false);
  const componentRef = useRef(null);

  const showInfo = () => {
    setPopupVisible(true);
  };

  const onHiding = () => {
    setPopupVisible(false);
  };

  const printQR = () => {
    exportComponentAsPNG(componentRef, {
      // html2CanvasOptions: {
      //   width: 375,
      //   height: 128,
      // },
    });
  };

  return (
    <React.Fragment>
      <Button
        onClick={showInfo}
        icon={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M144 32C170.5 32 192 53.49 192 80V176C192 202.5 170.5 224 144 224H48C21.49 224 0 202.5 0 176V80C0 53.49 21.49 32 48 32H144zM128 96H64V160H128V96zM144 288C170.5 288 192 309.5 192 336V432C192 458.5 170.5 480 144 480H48C21.49 480 0 458.5 0 432V336C0 309.5 21.49 288 48 288H144zM128 352H64V416H128V352zM256 80C256 53.49 277.5 32 304 32H400C426.5 32 448 53.49 448 80V176C448 202.5 426.5 224 400 224H304C277.5 224 256 202.5 256 176V80zM320 160H384V96H320V160zM352 448H384V480H352V448zM448 480H416V448H448V480zM416 288H448V416H352V384H320V480H256V288H352V320H416V288z"/></svg>`}
        style={{ marginTop: "0px", marginBottom: "0px" }}
        // width={18}
        // height={18}
      />
      <Popup
        visible={popupVisible}
        onHiding={onHiding}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        title="QR"
        width={500}
        height={250}
      >
        <Box
          direction="row"
          width="100%"
          //   align="space-between"
          style={{
            // border: "1px solid #70AD47",
            // padding: "10px 2px 10px 10px",
            alignContent: "flex-end",
          }}
          ref={componentRef}
        >
          <Item ratio={1}>
            <div
              style={{
                flexDirection: "column-reverse",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <QRCode
                // value={`http://218.232.108.62:3000/EqptMgmt/${type}/${SEQ}`}
                value={`https://betree.beccocro.com/EqptMgmt/${type}/${SEQ}`}
                size={128}
                level={"H"}
                // style={{ maringTop: "5px" }}
              />
            </div>
          </Item>
          <Item ratio={2}>
            <Box
              direction="row"
              width="100%"
              height="100%"
              style={{ marginTop: "5px" }}
            >
              <Item ratio={1}>
                <img
                  src={logoH2Img}
                  width="120"
                  height="60"
                  alt="common_logo_black"
                />
              </Item>
              <Item ratio={1}>
                <div
                  style={{
                    textAlign: "right",
                    marginRight: "7px",
                    color: "#006633",
                    fontFamily: "tahoma",
                    fontWeight: "bold",
                  }}
                >
                  [{codeNo}]
                </div>
                <div
                  style={{
                    textAlign: "right",
                    marginRight: "7px",
                    marginTop: "15px",
                    color: "#ACD22A",
                    fontFamily: "tahoma",
                    fontSize: "13px",
                  }}
                >
                  Best Clinical Companion
                </div>
              </Item>
            </Box>
            <div
              style={{
                fontSize: "13px",
              }}
            >
              BeccoCRO Inc.의 소중한 자산입니다. <br />
              제품을 습득하신 경우 아래의 번호로 연락 바랍니다.
              <br />
              02-6951-4401(대표)
            </div>
          </Item>
        </Box>
        <Button
          text="Print"
          stylingMode="text"
          type="default"
          onClick={printQR}
        />
      </Popup>
    </React.Fragment>
  );
}
